import {
  ADD_AI_MSG,
  ADD_AI_MSG_SUCCESS,
  ADD_AI_MSG_FAILURE,
  GET_AI_MSGS,
  GET_AI_MSGS_SUCCESS,
  GET_AI_MSGS_FAILURE,
  GET_AI_SESSIONS,
  GET_AI_SESSIONS_SUCCESS,
  GET_AI_SESSIONS_FAILURE,
  GET_AI_DOCS,
  GET_AI_DOCS_SUCCESS,
  GET_AI_DOCS_FAILURE,
  DELETE_AI_SESSION,
  DELETE_AI_SESSION_SUCCESS,
  DELETE_AI_SESSION_FAILURE,
} from "../constants";

export default class AIAction {
  static addAIMessage(payload, cb) {
    return {
      type: ADD_AI_MSG,
      payload,
      cb,
    };
  }
  static addAIMessageSuccess(payload) {
    return {
      type: ADD_AI_MSG_SUCCESS,
      payload,
    };
  }
  static addAIMessageFailure(payload) {
    return {
      type: ADD_AI_MSG_FAILURE,
      payload,
    };
  }
  static getAIMessages(payload, cb) {
    return {
      type: GET_AI_MSGS,
      payload,
      cb,
    };
  }
  static getAIMessagesSuccess(payload) {
    return {
      type: GET_AI_MSGS_SUCCESS,
      payload,
    };
  }
  static getAIMessagesFailure(payload) {
    return {
      type: GET_AI_MSGS_FAILURE,
      payload,
    };
  }
  static deleteAISession(payload, cb) {
    return {
      type: DELETE_AI_SESSION,
      payload,
      cb,
    };
  }
  static deleteAISessionSuccess(payload) {
    return {
      type: DELETE_AI_SESSION_SUCCESS,
      payload,
    };
  }
  static deleteAISessionFailure(payload) {
    return {
      type: DELETE_AI_SESSION_FAILURE,
      payload,
    };
  }
  static getAISessions(cb) {
    return {
      type: GET_AI_SESSIONS,
      cb,
    };
  }
  static getAISessionsSuccess(payload) {
    return {
      type: GET_AI_SESSIONS_SUCCESS,
      payload,
    };
  }
  static getAISessionsFailure(payload) {
    return {
      type: GET_AI_SESSIONS_FAILURE,
      payload,
    };
  }
  static getAIDocs(cb) {
    return {
      type: GET_AI_DOCS,
      cb,
    };
  }
  static getAIDocsSuccess(payload) {
    return {
      type: GET_AI_DOCS_SUCCESS,
      payload,
    };
  }
  static getAIDocsFailure(payload) {
    return {
      type: GET_AI_DOCS_FAILURE,
      payload,
    };
  }
}
